<div
  class="welcome"
  *ngIf="message && message.Enabled"
  role="dialog"
  aria-modal="true"
  [ngStyle]="accentVars"
>
  <div class="welcome__panel">
    <div class="welcome__head">
      <h1 class="welcome__heading">{{ message?.Heading }}</h1>
      <button
        type="button"
        class="ui-btn ui-btn--ghost ui-btn--sm ui-btn--icon welcome__close"
        aria-label="Close"
        (click)="close()"
      >
        ×
      </button>
    </div>

    <div class="welcome__body">
      <div class="welcome__media" *ngIf="message?.Image">
        <img [src]="message?.Image" alt="" />
      </div>

      <h2 class="welcome__title" *ngIf="message?.Title">{{ message?.Title }}</h2>
      <p class="welcome__copy" *ngIf="message?.Description">
        {{ message?.Description }}
      </p>
    </div>

    <div class="welcome__foot">
      <button type="button" class="ui-btn ui-btn--block" (click)="close()">
        Continue
      </button>
    </div>
  </div>
</div>
